<template>
  <div style="padding: 0px 24px;">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="门店">
        <el-select v-model="formInline.md" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合同号">
        <el-input v-model="formInline.hth"></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input v-model="formInline.pp"></el-input>
      </el-form-item>
      <el-form-item label="商户名称">
        <el-input v-model="formInline.shmc"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="chaxun">查询</el-button>
        <el-button type="warning" @click="print_all" class="chaxun">批量打印商户催交通知单</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" :height="conheight" style="width: 100% !important;" border>
      <el-table-column label="序号" width="50"><template slot-scope="scope">{{scope.$index+1}}</template></el-table-column>
      <el-table-column prop="FDMC" label="门店"></el-table-column>
      <el-table-column prop="F_PPMC" label="品牌"></el-table-column>
      <el-table-column prop="F_GYSMC" label="商户名称"></el-table-column>
      <el-table-column prop="F_LC" label="楼层"></el-table-column>
      <el-table-column prop="F_HTH" label="合同号"></el-table-column>
      <el-table-column prop="F_JZRQ" label="截止日期"></el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <span class="menuname"><el-link icon="el-icon-download" @click="print(scope.row)">打印商户催交通知单</el-link></span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "shcjftzd",
  data() {
    return {
      options: [{value: '海雅百货南山店',label: '海雅百货南山店'}, 
      {value: '海雅百货东莞东城店',label: '海雅百货东莞东城店'},
      {value: '海雅缤纷城购物中心',label: '海雅缤纷城购物中心'},
      {value: '中山海雅缤纷天地',label: '中山海雅缤纷天地'}],
      tableData:[],
      formInline: {
        md:'',
        hth:'',
        pp:'',
        shmc:'',
      },
      user:JSON.parse(sessionStorage.currentUser),
      conheight: window.innerHeight-136,
    };
  },
  methods: {
    print_all(){
      window.open("/fvue/print_shcjftzd_all","_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
    },
    print(row){//打印
        window.open("/fvue/print_shcjftzd?ID="+row.ID_,"_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
    },
    getDate(currentDate){
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = year+month;
      return formattedDate;
    },
    onSubmit() {
      this.tableData = [];
      let sql = "";
      if(this.user.username=='付婉婷'){//查看全部
        sql = "select * from V_ZSPT_SHCJTZD where 1=1 ";
      }else if(this.formInline.hth.length>0){
        sql = "select * from V_ZSPT_SHCJTZD where 1=1 ";
      }else{
        sql = "select * from V_ZSPT_SHCJTZD where ((select 'SZHY'||ghdwdm from ht where to_number(hth)=to_number(F_hth))='"+this.user.account+
        "' or f_kjry=(select fullname_ from uc_user where id_='"+this.user.userId+"')) ";
      }
      if(this.formInline.md.length>0){
        sql += " and instr(FDMC,'"+this.formInline.md+"',1,1)>0";
      }
      if(this.formInline.hth.length>0){
        sql += " and instr(F_HTH,'"+this.formInline.hth+"',1,1)>0";
      }
      if(this.formInline.pp.length>0){
        sql += " and instr(F_PPMC,'"+this.formInline.pp+"',1,1)>0";
      }
      if(this.formInline.shmc.length>0){
        sql += " and instr(F_GYSMC,'"+this.formInline.shmc+"',1,1)>0";
      }
      sql += " order by F_JZRQ desc";
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
          sessionStorage.setItem("cjsql",sql);
        }
      });
    },
    getList(){
      let sql = "select * from V_ZSPT_SHCJTZD WHERE 1=1  ";
      if(this.user.username=='付婉婷'){//查看全部
       sql += "order by F_JZRQ desc";
      }else{
       sql += "and ((select 'SZHY'||ghdwdm from ht where to_number(hth)=to_number(F_hth))='"+this.user.account+
        "' or f_kjry=(select fullname_ from uc_user where id_='"+this.user.userId+"'))  order by F_JZRQ desc";
      }
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
          sessionStorage.setItem("cjsql",sql);
        }
      });
    },
  },
  mounted(){
    this.getList();
    let currentDate = new Date(); // 获取当前日期和时间
    currentDate.setMonth(currentDate.getMonth() - 2); // 将月份减去1
    this.formInline.ksny=currentDate;

    let currentDate1 = new Date(); // 获取当前日期和时间
    currentDate1.setMonth(currentDate1.getMonth() + 1); // 将月份减去1
    this.formInline.jsny=currentDate1;
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .el-table .cell{
  padding: 0px !important;
  text-align: center !important;
}
/deep/ .el-table th{
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
  .cell{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
/deep/ .el-table td{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
}
/deep/ .el-form-item--small .el-form-item__label{
  line-height: 48px !important;
  height: 48px !important;
  color: #292B44 !important;
  font-size: 14px;
}
/deep/ .el-form-item--small .el-form-item__content{
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item el-form-item--small{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item--small.el-form-item{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
  padding-right: 32px !important;
}
/deep/ .demo-form-inline{
  // height: 48px !important;
  // line-height: 48px !important;
  padding: 8px 0px !important;
}
/deep/ .chaxun{
  span{
    font-size:14px !important;
  }
}
</style>